<template>
  <a-link
    v-if="!inProgress && isVisible"
    :to="to"
    tabindex="0"
    class="a-view-more__wrapper"
    :class="dynamicClass"
    @click="onClick"
    @keydown.enter="onEnter"
    @focus="onFocus"
  >
    <a-icon
      :icon="dynamicIcon"
      :width="16"
      :height="16"
      class="a-view-more__icon"
    />
    <span class="a-view-more__text text-medium">
      {{ viewMoreText }}
    </span>
  </a-link>
  <a-spinner v-else-if="inProgress" disable-transition />
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon'
import { PROP_TYPES, propValidator } from '@/utils/validators'
import ASpinner from 'shared/ASpinner'
import {
  VIEW_MORE_STYLE,
  CLASS_BY_VIEW_MORE_STYLE,
  VIEW_MORE_TEXT
} from 'shared/AViewMore/enums'

const VIEW_MORE_STYLE_VALUES = Object.values(VIEW_MORE_STYLE)

export default {
  name: 'AViewMore',
  components: { AIcon, ASpinner },
  props: {
    to: propValidator([PROP_TYPES.STRING, PROP_TYPES.OBJECT], false, ''),
    expandable: propValidator([PROP_TYPES.BOOLEAN], false, false),
    inProgress: propValidator([PROP_TYPES.BOOLEAN], false, false),
    page: propValidator([PROP_TYPES.NUMBER], false),
    pagesCount: propValidator([PROP_TYPES.NUMBER], false),
    viewMoreStyle: propValidator(
      [PROP_TYPES.STRING],
      false,
      VIEW_MORE_STYLE.LINK,
      value => VIEW_MORE_STYLE_VALUES.includes(value)
    )
  },
  data() {
    return {
      previousFocusElement: null,
      isExpanded: false
    }
  },
  consts: { ICON },
  computed: {
    viewMoreText() {
      return this.isExpanded ? VIEW_MORE_TEXT.EXPANDED : VIEW_MORE_TEXT.DEFAULT
    },
    isPaginated() {
      return this.page != null && this.pagesCount != null
    },
    isVisible() {
      if (!this.isPaginated) return true

      if (!this.pagesCount) return false

      return this.page !== this.pagesCount - 1
    },
    dynamicIcon() {
      return this.isExpanded ? ICON.MINUS_CIRCLE_ICON : ICON.PLUS_CIRCLE_ICON
    },
    dynamicClass() {
      return {
        [CLASS_BY_VIEW_MORE_STYLE[this.viewMoreStyle]]: true
      }
    }
  },
  methods: {
    onEnter(event) {
      event.preventDefault()

      this.$emit('click', event)
      this.handleExpandedState()

      if (this.previousFocusElement) {
        this.previousFocusElement.focus()
        this.previousFocusElement = null
      }
    },
    onClick() {
      this.$emit('click')
      this.handleExpandedState()
    },
    onFocus(event) {
      this.previousFocusElement = event.relatedTarget
    },
    handleExpandedState() {
      if (!this.expandable) return

      this.isExpanded = !this.isExpanded
      this.$emit('expanded-state-change', this.isExpanded)
    }
  }
}
</script>

<style lang="scss" scoped>
.a-view-more__wrapper {
  display: flex;
  color: $c--black;
  fill: $c--mid-purple;
  align-items: center;
  transition: 0.1s;
  user-select: none;
  cursor: pointer;

  &:hover {
    color: $c--mid-purple;
    text-decoration: underline;
  }
}

.a-view-more__link {
  justify-content: flex-end;
}

.a-view-more__button {
  height: 40px;
  padding: 8px 24px;
  justify-content: center;
  align-self: stretch;
  border-radius: 4px;
  background: $c--gray-soft;
}

.a-view-more__expandable {
  padding: 6px 16px;
  justify-content: center;
  background: $c--white;
  color: $c--black;
  fill: $c--black;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid $c--gray-light;

  &:hover {
    background: $c--light-purple-2;
    text-decoration: none;
    color: $c--dark-purple;
    fill: $c--dark-purple;
  }

  .a-view-more__text {
    margin-left: 10px;
  }
}

.a-view-more__expandable {
  padding: 6px 16px;
  justify-content: center;
  background: $c--white;
  color: $c--black;
  fill: $c--black;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid $c--gray-light;

  &:hover {
    background: $c--light-purple-2;
    text-decoration: none;
    color: $c--dark-purple;
    fill: $c--dark-purple;
  }

  .a-view-more__text {
    margin-left: 10px;
  }
}

.a-view-more__text {
  margin-left: 5px;
  font-weight: 700;
}
</style>
